import { isValid as isCnpjValidCore, normalize as normalizeCnpj, CNPJ_REGEX } from './CnpjUtils';
export var cnpjPattern = CNPJ_REGEX;
export var isCnpjValid = function (cnpj) { return isCnpjValidCore(cnpj); };
export var cpfPattern = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
export var isCpfValid = function (cpf) { return cpfPattern.test(cpf); };
export var cepPattern = /^\d{5}-\d{3}$/;
export var isCepValid = function (cep) { return cepPattern.test(cep); };
export var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export var isEmailValid = function (email) { return emailPattern.test(email); };
export var hasCpfValid = function (value) { return !!value && value.length === 11; };
export var hasCnpjValid = function (value) {
    return !!value && normalizeCnpj(value).length === 14;
};
export var hasValue = function (value) { return !!value && value !== ''; };
export var hasErrors = function (errorObject) { return Object.entries(errorObject).some(function (_a) {
    var key = _a[0], value = _a[1];
    return !!value;
}); };
export var verticePattern = /^[A-Za-z]{3}-[A-Za-z]-\d{4}$/;
export var isVerticeValid = function (vertice) { return verticePattern.test(vertice); };
export var coordenadaGMSPattern = /^\d{2}° \d{2}' \d{2}\.\d$/;
export var isCoordenadaGMSValid = function (valor) { return coordenadaGMSPattern.test(valor); };
export var metrosPattern = /^\d,\d{2}$/;
export var isMetrosValid = function (valor) { return metrosPattern.test(valor); };
